"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEndpointProposalTally = exports.generateEndpointProposals = exports.ProposalStatus = void 0;
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["Unspecified"] = "PROPOSAL_STATUS_UNSPECIFIED";
    ProposalStatus["Deposit"] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    ProposalStatus["Voting"] = "PROPOSAL_STATUS_VOTING_PERIOD";
    ProposalStatus["Passed"] = "PROPOSAL_STATUS_PASSED";
    ProposalStatus["Rejected"] = "PROPOSAL_STATUS_REJECTED";
    ProposalStatus["Failed"] = "PROPOSAL_STATUS_FAILED";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
function generateEndpointProposals() {
    return `/cosmos/gov/v1beta1/proposals`;
}
exports.generateEndpointProposals = generateEndpointProposals;
function generateEndpointProposalTally(proposalId) {
    return `/cosmos/gov/v1beta1/proposals/${proposalId}/tally`;
}
exports.generateEndpointProposalTally = generateEndpointProposalTally;
//# sourceMappingURL=gov.js.map